import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid2, Stack, ThemeProvider } from '@mui/material';
import Container from '@mui/material/Container';

import RunnerContent from './components/RunnerContent'
import ObiContent from './components/ObiContent'
import theme from './themes/classicLight'
import Intro from './components/Intro';
import About from './components/About';
import Importance from './components/Importance';
import Features from './components/Features';
import Footer from './components/Footer';
import Content from './components/Content';

export default function HideAppBar(props) {
  return (
    <React.Fragment>

      <About />
        <Content />
        <Intro />
        <br />
        <br />
        <Importance />
        <br />
        <br />
        <Features />
        <br />
        <br />
        <Container maxWidth="xl" >
          <Grid2 container justifyContent={'space-between'}>
            <Grid2 size={{ xs: 12 }}>
              <Typography variant='h4' gutterBottom>Deployment Options</Typography>

            </Grid2>
          </Grid2>
        </Container>
        <RunnerContent />
        <ObiContent />


        <br />
        <Container maxWidth="xl" >
          <Grid2 container justifyContent={'space-between'}>
            <Grid2 size={{ xs: 12 }}>
              <a href={process.env.REACT_APP_RESOURCES} target='_blank' rel="noreferrer">
                <Button variant="contained" size="large">Click here to learn more and explore</Button>

              </a>

            </Grid2>
          </Grid2>
        </Container>
        <br />
        <br />
        <Footer />

    </React.Fragment>
  );
}



